<template>
  <div>
    <label class="text-12 font-bold opacity-80 uppercase mt-1 mb-2 text-gray-800" :id="uid">
      {{ $t('transfer_search.amount_title') }}
    </label>
    <div class="relative mt-1">
      <input
        type="number"
        inputmode="numeric"
        :min="1"
        :step="1"
        class="w-full h-16 pr-14 pl-3 bg-white rounded-8 border-3 border-brand-600 placeholder:font-normal placeholder:text-gray-400 font-bold outline-none"
        :aria-labelledby="uid"
        :value="amountValue || undefined"
        :placeholder="amountPlaceholder"
        required
        @keydown="onKeydown"
        @input="onInput"
        @invalid="onInvalid"
        @focus="onFocus"
      />
      <span
        class="absolute right-3 inset-y-0 content-center font-bold text-gray-600 pointer-events-none"
        >{{ currencyValue }}</span
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
const uid = useId()

const props = withDefaults(
  defineProps<{
    amountValue: number
    amountPlaceholder?: string
    currencyValue: string
    customError?: string
  }>(),
  { currencyValue: '' },
)

const emit = defineEmits(['input-amount'])

const { subscriptions } = useRuntimeConfig().public

function onFocus(event: Event) {
  if (__IS_MOBILE_APP__) {
    setTimeout(() => {
      const target = event.target as HTMLInputElement
      target.scrollIntoView()
    }, 300)
  }
}

function onInvalid(event: Event) {
  if (props.customError) {
    const target = event.target as HTMLInputElement
    target.setCustomValidity(props.customError)
  }
}

function onKeydown(event: Event) {
  if ('key' in event) {
    if (event.key === 'e' || event.key === '.') {
      event.preventDefault()
    }
  }
}

function onInput(event: Event) {
  if (event.target) {
    const target = event.target as HTMLInputElement
    target.setCustomValidity('')
    target.reportValidity()

    if (target.value) {
      const value = target.value.replace(/[^0-9.]/g, '')
      let number = Number(Number.parseFloat(value).toFixed(0))
      if (number > subscriptions.maxAmount) {
        number = subscriptions.maxAmount
      }
      target.value = Number.isNaN(number) ? '' : number.toString(10)
    }
    emit('input-amount', target.valueAsNumber)
  }
}
</script>
